import React from 'react';
// import { Api, Utils } from '@jesseteal/teal-react'

const LogoHeader = () => {
  return (
    <div className="tc">
      <img src="/pluscologo.png" alt="logo" style={{ width: 200 }} />
    </div>
  );
};

export default LogoHeader;
